import { FillPreview, Tooltip } from "@wix/design-system";
import React from "react";
import { SWATCH, SWATCH_TOOLTIP } from "../../data-hooks.js";
const SingleColorSwatch = ({
  fill,
  selectedColor,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className,
  onFocus,
  setRef,
  index
}) => {
  return /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      appendTo: (el) => Boolean(el.getAttribute("data-hook")?.includes("ricos-portal")),
      content: fill,
      dataHook: SWATCH_TOOLTIP,
      enterDelay: 1e3,
      size: "small",
      placement: "top",
      moveBy: { y: 10 },
      className
    },
    /* @__PURE__ */ React.createElement(
      FillPreview,
      {
        id: index,
        selected: selectedColor?.toUpperCase() === fill.toUpperCase(),
        "aria-selected": selectedColor?.toUpperCase() === fill.toUpperCase(),
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick(fill);
        },
        onMouseEnter: () => onMouseEnter?.(fill),
        onMouseLeave,
        fill,
        dataHook: SWATCH,
        onFocus,
        "aria-label": `${fill} color swatch`,
        tabIndex: -1,
        ref: setRef,
        role: "option"
      }
    )
  );
};
export {
  SingleColorSwatch
};
//# sourceMappingURL=single-color-swatch.js.map
